module.exports = __webpack_public_path__ + "static/media/p1-event-mask-home-desktop.e331ec72.png";